import React, { Component } from 'react';
import { Button, Paper, TextField, Grid } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import PropTypes from 'prop-types';

import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import i18n from '../../i18n';

import SimpleDialogFragment from './SimpleDialogFragment';
import '../../assets/stylesheets/Setting.css';

const initialState = {
  projectName: undefined,
  notes: undefined,
  startDate: undefined,
  endDate: undefined
};

class EditSpecialProjectModal extends Component {
  constructor(props) {
    super(props);

    this.state = initialState;
  }

  handleChange = event => {
    const {
      target: { name, value }
    } = event;

    this.setState({
      [name]: value
    });
  };

  changeStartDate = startDate => {
    this.setState({ startDate });
  };

  changeEndDate = endDate => {
    this.setState({ endDate });
  };

  handleEdit = () => {
    const { editSpecialProject, selectedValidSpecialProject } = this.props;
    let { projectName, notes, startDate, endDate } = this.state;
    if (!projectName) {
      projectName = selectedValidSpecialProject.specialProjectName;
    }
    if (!notes) {
      notes = selectedValidSpecialProject.notes;
    }
    if (!startDate) {
      startDate = selectedValidSpecialProject.startDate;
    }
    if (!endDate) {
      endDate = selectedValidSpecialProject.endDate;
    }
    editSpecialProject(
      selectedValidSpecialProject.id,
      projectName,
      notes,
      startDate,
      endDate
    );
    this.setState(initialState);
  };

  closeModal = () => {
    const { toggleEditModal } = this.props;
    this.setState(initialState);
    toggleEditModal();
  };

  render() {
    const {
      showEditModal,
      toggleEditModal,
      selectedValidSpecialProject
    } = this.props;
    let { startDate, endDate } = this.state;
    const { projectName, notes } = this.state;

    // Material UI Date Picker does not have a defaultValue prop, this is to work around that.
    if (!startDate && selectedValidSpecialProject) {
      startDate = selectedValidSpecialProject.startDate;
    }
    if (!endDate && selectedValidSpecialProject) {
      endDate = selectedValidSpecialProject.endDate;
    }
    return (
      <Modal open={showEditModal} onClose={this.closeModal}>
        <Paper className="editModal">
          {!selectedValidSpecialProject ? (
            <SimpleDialogFragment
              title={i18n.t('specialProject:warningSpecialProjectModal')}
              buttonLabel={i18n.t('close')}
              onClick={toggleEditModal}
            />
          ) : (
            <div>
              <Grid container>
                <Grid item xs={12}>
                  <span>{i18n.t('specialProject:editModal')}</span>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    defaultValue={
                      selectedValidSpecialProject.specialProjectName
                    }
                    value={projectName}
                    id="projectName"
                    label={i18n.t('specialProject:projectName')}
                    name="projectName"
                    autoFocus
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    multiline
                    rows="6"
                    defaultValue={selectedValidSpecialProject.notes}
                    value={notes}
                    id="notes"
                    label={i18n.t('specialProject:notes')}
                    name="notes"
                    autoFocus
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={2}>
                  {i18n.t('specialProject:startDate')}
                </Grid>
                <Grid item xs={4}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    className="bookingSelectField"
                  >
                    <DatePicker
                      value={startDate}
                      onChange={this.changeStartDate}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={2}>
                  {i18n.t('specialProject:endDate')}
                </Grid>
                <Grid item xs={4}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    className="bookingSelectField"
                  >
                    <DatePicker value={endDate} onChange={this.changeEndDate} />
                  </MuiPickersUtilsProvider>
                </Grid>
                <br />
                <Grid item xs={6}>
                  <Button
                    onClick={this.handleEdit}
                    className="ssenseButton ssensePrimary"
                    disabled={projectName === ''}
                  >
                    {i18n.t('confirm')}
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    onClick={this.closeModal}
                    className="ssenseButton ssenseDefault"
                  >
                    {i18n.t('cancel')}
                  </Button>
                </Grid>
              </Grid>
            </div>
          )}
        </Paper>
      </Modal>
    );
  }
}

EditSpecialProjectModal.propTypes = {
  showEditModal: PropTypes.bool.isRequired,
  toggleEditModal: PropTypes.func.isRequired,
  editSpecialProject: PropTypes.func.isRequired,
  selectedValidSpecialProject: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.array
    ])
  )
};

EditSpecialProjectModal.defaultProps = {
  selectedValidSpecialProject: null
};

export default EditSpecialProjectModal;
